import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const DownloadsService = {
  actions: {
    fetchDownloadsCount ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/downloads/count',
          method: 'GET'
        })
          .then(resp => {
            const count = resp.data.count
            commit('api_success')
            resolve(resp)
            return count
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchDownloads ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/downloads',
          method: 'GET'
        })
          .then(resp => {
            const downloads = resp.data.downloads
            commit('api_success')
            resolve(resp)
            return downloads
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    }
  }
}

export default DownloadsService



// WEBPACK FOOTER //
// ./src/store/modules/downloads.module.js